import {
	EuiFlexGroup,
	EuiFlexItem,
	EuiHighlight,
	EuiTextColor
} from '@equipmentshare/ds2'

import ComboBoxEui from 'components/ComboBox/comboBox.eui'
import { AdvancedComboBoxProps, ComboBoxOptionOption } from 'components/ComboBox/types'

export default function AdvancedComboBoxEui<T>( { getSecondaryText, ...props }: AdvancedComboBoxProps<T> ) {
	const renderSecondaryText = ( text: string | string[], searchValue: string ) => {
		if ( typeof text === 'string' ) {
			return <EuiHighlight search={searchValue}>{text}</EuiHighlight>
		} else {
			const flexItems: React.ReactNode[] = []
			let i = 0
			for ( const t of text ) {
				flexItems.push( <EuiFlexItem key={`text-item-${i}`} grow={false}><EuiHighlight search={searchValue}>{t}</EuiHighlight></EuiFlexItem> )
				i++
			}
			return (
				<EuiFlexGroup justifyContent="spaceBetween">
					{flexItems}
				</EuiFlexGroup>
			)
		}
	}

	const renderComboBoxOption = ( option: ComboBoxOptionOption<T>, searchValue: string ) => {
		if ( option.value ) {
			return (
				<>
					<EuiHighlight search={searchValue}>{props.getName( option.value )}</EuiHighlight>
					<br />
					<EuiTextColor style={{ display: 'block' }} color="subdued">
						<small>
							{ renderSecondaryText( getSecondaryText( option.value ), searchValue ) }
						</small>
					</EuiTextColor>
				</>
			)
		}
		return null
	}

	return (
		<ComboBoxEui
			{...props}
			rowHeight={60}
			renderOption={renderComboBoxOption}
		/>
	)
}
